import { FeatureFlagNames } from 'constants/app.constant';
import { useSelector } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { isWguCourse } from 'reports/cw/helpers/wgu.helper';
import { isFeatureEnabled } from 'services/feature-flag.service';
var useWguExperience = function () {
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var courseId = useSelector(appSelectors.getSelectedCourse);
    var courseSectionInfo = useSelector(courseSelectors.getCourseSectionInfo);
    return isWguCourse(courseSectionInfo) && isFeatureEnabled(featureFlags, FeatureFlagNames.USPD_WGU_EXPERIENCE_ENABLED, courseId === null || courseId === void 0 ? void 0 : courseId.toString());
};
export default useWguExperience;
